import { Column } from '@table/classes/column.class';
import { CellDisplay } from '@table/enums/cell-display.enum';

export class LastUpdatedColumn extends Column {
    title = 'payroll.settings.lastUpdated';
    property = 'updatedAt';
    sortable = false;
    type: CellDisplay = CellDisplay.date;
}
